import React, { useEffect } from 'react';
import ValidationTypes from '../../../util/validationTypes';
import useLoadingForm from '../../../hooks/loadingFormHook';
import LoadButton from '../LoadButton';
import Username from '../../../static/dashboard/username.svg';
import Password from '../../../static/dashboard/password.svg';
import LoadingSpinner from '../../../static/dashboard/loadingspinner.svg';
import BackArrow from '../../../static/dashboard/backarrow.svg';
import '../../../styles/dashboard/settings/SettingsChangeDepop.css';

export default function SettingsChangeDepop({ history }) {
    // The function that we wait for
    const submitHandler = () => {
        return fetch("https://flash.siwalik.in/delay/500",
        {method: "GET"});
    }

    // Callback for when loading function ends
    const submitCallback = (data) => {
        // history.push('/dashboard');
    };

    const changeFormRules = {
        username: [ValidationTypes.requiredString],
        password: [ValidationTypes.requiredString]
    };

    const { formData, handleChange, loading, loaded, handleSubmit, errorMapping } = useLoadingForm({
        username: '',
        password: ''
    }, submitHandler, submitCallback, null, changeFormRules);


    useEffect(() => {
        const img = new Image();
        img.src = LoadingSpinner;
    }, []);

    return (
        <div className="SettingsChangeDepop center-dashboard-content">
            <img 
            className="back-arrow"
            onClick={(e) => history.goBack()}
            src={BackArrow} 
            alt="Go Back"/>
            <div className="content">
                <div className="header">
                    <h1>Change Your Account</h1>
                    <p>Connect Salewave with another Depop account.</p>
                </div>
                <form 
                onSubmit={handleSubmit}
                className="formDashboard">
                    <div className={`username ${errorMapping.username ? 'form-error-input' : ''}`}>
                        <div><img src={Username} alt="@"/></div>
                        <input 
                        className="withIcon"
                        type="text"
                        name="username"
                        value={formData.username}
                        placeholder="Username"
                        onChange={handleChange} />
                    </div>
                    {errorMapping.username && <p className="form-error">{errorMapping.username}</p>}
                    <div className={`password ${errorMapping.password ? 'form-error-input' : ''}`}>
                        <div><img src={Password} alt=""/></div>
                        <input 
                        className="withIcon"
                        type="password"
                        name="password"
                        value={formData.password}
                        placeholder="password"
                        onChange={handleChange} />
                    </div>
                    {errorMapping.password && <p className="form-error">{errorMapping.password}</p>}
                    <LoadButton 
                    loading={loading}
                    loaded={loaded}
                    defaultText="Change Account"
                    loadingText="Changing Account"
                    loadedText="Changes Complete"
                    theme="black" />
                </form>
            </div>

        </div>
    )
}